export function decideSearchAction({
  value,
  bibleReference,
  matchedPerson,
  matchedPage,
  showSuggestions = false,
  activeSuggestionIndex = -1,
  flatSuggestions = [],
}) {
  const trimmed = String(value || "").trim();
  if (!trimmed) return null;

  if (
    showSuggestions &&
    activeSuggestionIndex >= 0 &&
    flatSuggestions[activeSuggestionIndex]
  ) {
    const suggestion = flatSuggestions[activeSuggestionIndex];

    if (suggestion.type === "scripture") {
      return { type: "open-scripture", value: suggestion.title };
    }

    if (suggestion.route) {
      return { type: "navigate", value: suggestion.route };
    }
  }

  if (bibleReference) {
    return { type: "open-scripture", value: bibleReference };
  }

  if (matchedPerson?.id) {
    return { type: "navigate", value: `/people/${matchedPerson.id}` };
  }

  if (matchedPage?.route) {
    return { type: "navigate", value: matchedPage.route };
  }

  return { type: "navigate", value: `/search?q=${encodeURIComponent(trimmed)}` };
}